import { MiscellaneousConfig } from "ui/pages/TemplatePreview/constants";
import {
  TEAMS_MESSAGES,
  TEAMS_SECTION_FORM_KEYS,
} from "../../../sidebar.constant";

export const useTeamsHandlers = ({
  error_object,
  set_error_object,
  set_section_name,
  set_nav_section_name,
  updateData,
  setField,
  hiddenFields = [],
}) => {
  const handleSectionNameChange = (e) => {
    const value = e.target.value;
    set_error_object({
      ...error_object,
      sectionNameLength:
        value.length >= MiscellaneousConfig.maxShortTitleLenght
          ? `${TEAMS_MESSAGES.MAX_FIELD_LENGTH} ${MiscellaneousConfig.maxShortTitleLenght} ${TEAMS_MESSAGES.REACHED}`
          : false,
    });
    set_section_name(value);
    setField(TEAMS_SECTION_FORM_KEYS.section_name.field, value);
  };

  const handleNavSectionNameChange = (e) => {
    const value = e.target.value;
    set_error_object({
      ...error_object,
      sectionNameLength:
        value.length >= MiscellaneousConfig.maxShortTitleLenght
          ? `${TEAMS_MESSAGES.MAX_FIELD_LENGTH} ${MiscellaneousConfig.maxShortTitleLenght} ${TEAMS_MESSAGES.REACHED}`
          : false,
    });
    set_nav_section_name(value);
    setField(TEAMS_SECTION_FORM_KEYS.nav_section_name.field, value);
  };

  const handleHeadingChange = (e) => {
    const value = e.target.value;
    set_error_object({
      ...error_object,
      sectionHeading:
        value.length >= MiscellaneousConfig.maxTitleLength
          ? `${TEAMS_MESSAGES.MAX_FIELD_LENGTH} ${MiscellaneousConfig.maxTitleLength} ${TEAMS_MESSAGES.REACHED}`
          : false,
    });
    updateData(value, TEAMS_SECTION_FORM_KEYS.heading.key);
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    set_error_object({
      ...error_object,
      sectionDescription:
        value.length >= MiscellaneousConfig.maxDescLength
          ? `${TEAMS_MESSAGES.MAX_FIELD_LENGTH} ${MiscellaneousConfig.maxDescLength} ${TEAMS_MESSAGES.REACHED}`
          : false,
    });
    updateData(value, TEAMS_SECTION_FORM_KEYS.description.key);
  };

  const showSectionTitle = (key) => {
    return !hiddenFields.includes(key);
  };

  return {
    handleSectionNameChange,
    handleNavSectionNameChange,
    handleHeadingChange,
    handleDescriptionChange,
    showSectionTitle,
  };
};
